import React from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';
import {addSlash} from '../../utils/urlUtils';

const PagingRouter = (Component, defaultPage = 0, pageOptional) => ({match, ...props}) => {
  const getPageUrl = page => `${addSlash(match.url)}${typeof page !== 'undefined' ? page : ''}`;
  return (
    <Switch>
      <Route
        path={`${addSlash(match.path)}:page${pageOptional ? '?' : ''}`}
        render={routerProps => <Component {...{...props, ...routerProps, getPageUrl}} />}
      />
      <Redirect to={getPageUrl(defaultPage)} />
    </Switch>
  );
};

export default PagingRouter;
